import { createClient } from 'next-sanity';

export const projectId = process.env.NEXT_PUBLIC_SANITY_PROJECT_ID || '';
export const dataset = process.env.NEXT_PUBLIC_SANITY_DATASET || 'production';
export const apiVersion = '2025-01-01';

export const client = createClient({
  projectId,
  dataset,
  apiVersion,
  useCdn: true, // public dataset, no token needed for published reads
  stega: {
    studioUrl: '/studio',
  },
});
